<template>
  <v-badge :content="taskCount" color="red" :value="taskCount" offset-y="12">
    <v-menu offset-y nudge-bottom="10" v-model="menuOpen">
      <template v-slot:activator="{ on:menu }">
        <v-tooltip bottom open-delay="1000" nudge-bottom="10">
          <template v-slot:activator="{ on: tooltip }">
            <v-btn icon small class="ml-2" v-on="{...tooltip,...menu}"><v-icon>mdi-format-list-checks</v-icon></v-btn>
          </template>
          Outsanding tasks
        </v-tooltip>
      </template>
      <v-card width="500">
        <v-card-title class="pb-0">
          {{tasks.length === 0 ? 'No ' : ''}}Outstanding tasks
        <v-spacer/><v-btn x-small text :to="{name:'PlanningTasks'}">See all tasks</v-btn></v-card-title>
        <v-list max-height="300px" class="overflow-y">
          <v-list-item v-for="task in tasks" :key="task.id" @click="performTask(task)">
            <v-list-item-icon><v-icon>mdi-checkbox-blank-outline</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title :class="{'red--text':task.startDate < today}">{{task.description}}</v-list-item-title>
              <v-list-item-subtitle class="text-caption">Due {{task.startDate | formatDate}}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="!!task.primitiveType">
              <v-btn icon>
                <v-icon @click.stop="print(task)">mdi-printer</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>

    <v-dialog v-model="showAdHoc" persistent max-width="400">
      <v-card>
        <v-card-title>Perform activity</v-card-title>
        <v-divider/>
        <v-card-text class="pa-4">
          <v-container>
            <v-row>
              <v-col class="text-h6 mb-4">
                {{activity.description}}
              </v-col>
            </v-row>
            <v-row cols="12" sm="6">
              <date-picker v-model="activityComplete" label="Completed"/>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer/>
          <v-btn plain color="primary" @click="showAdHoc=false">Cancel</v-btn>
          <v-btn color="primary" @click="completeActivity()" :saving="loading">Complete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-badge>

</template>

<script>
import {format} from 'date-fns'

import productionBlendingPrintBlend from '@/views/production/blending/productionBlendingPrintBlend'
import productionBottlingPrintBottling from '@/views/production/bottling/productionBottlingPrintBottling'
import productionDistillingPrintDistillation from '@/views/production/distilling/productionDistillingPrintDistillation'
import productionMashingPrintMash from '@/views/production/mashing/productionMashingPrintMash'

export default {
  name: 'PlanningTasksOutstanding',
  mixins: [productionBlendingPrintBlend,productionBottlingPrintBottling,productionDistillingPrintDistillation,productionMashingPrintMash],
  data() {
    return {
      menuOpen: false,
      loading: false,
      tasks: [],
      showAdHoc: false,
      activity: {},
      activityComplete: '',
      today: format(new Date(), 'yyyy-MM-dd')
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    taskCount() {
      return this.$store.state.taskCount;
    }
  },
  watch: {
    async menuOpen() {
      if (this.menuOpen === true) {
        const results = await this.$apiCall(`query PlanningTasksOutstanding {
                                                activitiesForUser(waiting:false) {
                                                  id,primitiveType,primitiveId,description,siteId,siteName,roleName,startDate,endDate,quantity
                                                }
                                              }`,
                                            {});
        if (!results.error) {
          this.tasks = results.data.activitiesForUser.filter(task => task.startDate <= this.today);
        }
      }
    }
  },
  methods: {
    async performTask(activity) {
      switch (activity.primitiveType) {
        case 'MashBill':
          this.$router.push({name:'ProductionMashingEditNew',params:{mashBillId:activity.primitiveId,volume:activity.quantity,activityId:activity.id}});
          break;
        case 'Process':
          this.$router.push({name:'ProductionDistillingEditNew',params:{processId:activity.primitiveId,activityId:activity.id}});
          break;
        case 'Formula':
          this.$router.push({name:'ProductionBlendingEditNew',params:{formulaId:activity.primitiveId,volume:activity.quantity,activityId:activity.id}});
          break;
        case 'Product':
          this.$router.push({name:'ProductionBottlingEditNew',params:{productId:activity.primitiveId,cases:activity.quantity,activityId:activity.id}});
          break;
        case 'Item':
          this.$router.push({name:'ProductionAssemblyEditNew',params:{itemId:activity.primitiveId,quantity:activity.quantity,activityId:activity.id}});
          break;
        default:
          this.activity = activity;
          this.activityComplete = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
          this.showAdHoc = true;
          break;
      }
    },
    async completeActivity() {
      await this.$apiCall(`mutation PlanningTasksOutstanding($id: ID!, $date: DateTime!) {
                              activityComplete(id:$id, date:$date) {
                                id,completed
                              }
                            }`,
                          {id:this.activity.id, date:this.activityComplete});
      this.showAdHoc = false;
      this.$store.dispatch('checkTasks', true);
    },
    print(activity) {
      if (activity.primitiveType === 'Formula')
        this.printBlend(activity.primitiveId,
                       {date:activity.startDate, siteName:activity.siteName, quantity:activity.quantity, performBy:activity.roleName ?? ''},
                        true);
      else if (activity.primitiveType === 'MashBill')
        this.printMash(activity.primitiveId,
                       {date:activity.startDate, siteName:activity.siteName, quantity:activity.quantity, performBy:activity.roleName ?? ''},
                        true);
      else if (activity.primitiveType === 'Process')
        this.printDistillation(activity.primitiveId,
                       {date:activity.startDate, siteName:activity.siteName, quantity:activity.quantity, performBy:activity.roleName ?? ''},
                        true);
      else if (activity.primitiveType === 'Product')
        this.printBottling(activity.primitiveId,
                       {date:activity.startDate, siteName:activity.siteName, quantity:activity.quantity, performBy:activity.roleName ?? ''},
                        true);
    }
  }
}
</script>